<template>
  <div class="aui-scrollView" style="background-color: #ffffff">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">充值中心</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <section class="aui-scrollView no-foot">
      <div class="home-top">
        <div class="top-content">
          <img src="../../../assets/img/user.png"/>
          <div class="top-r">
            <p>账号：{{ purchaseInfo.userInfo.account }}</p>
            <p>密码：{{ purchaseInfo.userInfo.password }}</p>
          </div>
        </div>
        <div class="assert">
          <div class="vip">
            <template v-if="purchaseInfo.userInfo.vipType === 'none'">
              <p class="title">未开通VIP</p>
            </template>
            <template v-else>
              <p class="title">VIP会员</p>
              <p class="in-vip">{{ purchaseInfo.userInfo.vipEndDate }}</p>
            </template>
          </div>
          <div class="coin">
            <p class="title t-r">阅币</p>
            <p class="coin-amount t-r">{{ purchaseInfo.userInfo.avaliableAmount }}</p>
          </div>
        </div>
      </div>
      <div class="bd-content">
        <div class="paybox">
          <h4>
            <img src="../../../assets/img/icon-10.png"/>账户充值
          </h4>
          <ul class="payul">
            <li
              v-for="(item) in purchaseInfo.payConfigs.filter(i => i.type === 'coin')"
              :class="{active: item.amountLevel == selected.amountLevel && item.type == selected.type}"
              :key="item.id"
              @click="selectAmount(item)"
            >
              <a class="ov">
                <p class="scolor 30">
                  <span class="f12 b">{{ getPriceText(item.amountLevel) }}元</span>
                </p>
                <p class="f12">{{ item.itemCount }}阅币</p>
                <p v-if="item.presentCount > 0" class="f16 scolor">赠送{{ item.presentCount }}阅币</p>
                <p class="tage_name" v-if="item.isRecommend ==='Y'">热销</p>
              </a>
            </li>
            <li
              v-for="(item) in purchaseInfo.payConfigs.filter(i => i.type === 'vip')"
              :class="{active: item.amountLevel == selected.amountLevel && item.type == selected.type}"
              :key="item.id"
              @click="selectAmount(item)"
            >
              <a class="ov">
                <p class="scolor 30">
                  <span class="f12 b">{{ getPriceText(item.amountLevel) }}元</span>
                </p>
                <p class="f12">{{ item.itemCount }}天全站免费看</p>
                <p v-if="item.title" class="f16 scolor">{{ item.title }}</p>
                <p class="tage_name" v-if="item.isRecommend ==='Y'">热销</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="pay-txt">
          <p>
            1.请务必保管您的充值账号和密码，建议您下载官方App登录此账号
            <a :href="getCommonInfo.appDownloadUrl" target="_blank">下载APP</a>
          </p>
          <p>2.如果充值成功付款未到账，联系在线客服进行处理即可（工作时间：11:00~21:00）</p>
          <p>3.账号丢失，付款未超过2个月可凭借账单咨询在线客服找回。（截图请发账单详情页，谢谢）</p>
          <p>4.会有网址或者APP访问不了的情况存在，请您提前保管自己充值账号以及邮箱。邮箱会在工作日回复网址问题。</p>
          <p>客服QQ：{{ getCommonInfo.customerServiceQQ }}</p>
          <p>客服邮箱：{{ getCommonInfo.customerServiceEmail }}</p>
        </div>

        <div class="btnbox-p fixed" style=" ">
          <button type="button" @click="charge" class="btn btn-pay">立即充值</button>
        </div>
        <div v-if="showConfirm" class="pay-fixed">
          <confirm :payConfig="selected" :subTypes="purchaseInfo.subTypes" :payPurposeId="payPurposeId"
                   :appType="appType"
                   @hide="hideConfirm()"></confirm>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PayConfirm from '@/components/layer2/pay/confirm'
// import Bottom from '@/components/layer1/bottom'
import payService from '../../../services/payService'
import { mapGetters } from 'vuex'
import userService from '../../../services/userService'
import { Kkconfig } from '../../../assets/js/config'
import kkUtil from '../../../assets/js/kk-util'

export default {
  name: 'purchase',
  data () {
    return {
      payPurposeId: '',
      purchaseInfo: {
        userInfo: {},
        payConfigs: [],
        subTypes: [],
        availableAmount: 0
      },
      selected: {},
      inBrowser: true,
      clientType: 'ios',
      appType: 'wap_browser',
      showConfirm: false
    }
  },
  computed: {
    ...mapGetters(['getCommonInfo'])
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    getPriceText (amount) {
      return parseFloat(amount / 100)
    },
    selectAmount (item) {
      this.selected = item
    },
    charge () {
      const { selected } = this
      if (selected.id) {
        this.showConfirm = true
      }
    },
    getPurchaseInfo () {
      payService.getPurchaseInfo(this.appType, this.$router)
        .then(res => {
          this.purchaseInfo = res.data
          if (this.purchaseInfo.payConfigs) {
            for (let i = 0; i < this.purchaseInfo.payConfigs.length; i++) {
              let item = this.purchaseInfo.payConfigs[i]
              if (item.isDefault === 'Y') {
                this.selected.amount = item.amountLevel
                this.selected.purpose = item.type
                this.selected.initiatorCode = item.initiatorCode
              }
            }
          }
          //老的用户被删了，那么就以新的用户为准
          let localUser = userService.getLocalUserInfo()
          if (typeof (localUser) == 'undefined' || localUser == null) {
            userService.updateLocalUserInfo(this.purchaseInfo.userInfo)
          } else {
            if (localUser.userId !== this.purchaseInfo.userInfo.userId) {
              userService.updateLocalUserInfo(this.purchaseInfo.userInfo)
            }
          }
          this.imUrl = Kkconfig.reqUrl.imUrl + '?account=' + this.purchaseInfo.userInfo.account
          // document.getElementById('purchaseReportUrl').href = getReportUrl(this.purchaseInfo.userInfo.account)
        })
    },
    hideConfirm () {
      this.showConfirm = false
    }
  },
  components: {
    confirm: PayConfirm
    // bottom: Bottom
  },
  created () {
    this.payPurposeId = this.$route.query.bookId
    if (!this.payPurposeId || this.payPurposeId == 'undefined') {
      this.payPurposeId = ''
    }
    this.getPurchaseInfo()
    this.$router.isBack = true
    this.inBrowser = !kkUtil.isInWebView()
    this.clientType = kkUtil.getClientType()
    if (this.inBrowser) {
      if (navigator.standalone) {
        this.appType = 'ios_desk'
      }
    } else {
      if (this.clientType == 'android') {
        this.appType = 'shell'
      } else {
        this.appType = 'other'
      }
    }
  }
}
</script>

<style scoped>
.pay-fixed {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
</style>
